import type { PrintComExcludeRules } from '@/lib/printcom/printing-method-selection';
import { isExcludedByConfiguredOptionRules } from './option-exclusions';

/** Only fixed quantity conflicts are decisive before the server chooses a
 * production technique. A method-specific exclusion can still be priceable
 * through another method and must reach the normal technique selector. */
export function isMatrixQuantityExcluded(
  excludes: PrintComExcludeRules | undefined,
  configuration: Record<string, unknown>,
  copies: number,
): boolean {
  const fixedQuantityRules = (excludes || []).filter((rule) =>
    Array.isArray(rule)
    && rule.some((condition) => condition.property === 'copies')
    && !rule.some((condition) => condition.property === 'printingmethod'),
  );
  return isExcludedByConfiguredOptionRules(fixedQuantityRules, (property) => ({
    value: property === 'copies' ? copies : configuration[property],
  }));
}
